import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { uccUsers } from './uccUsers.model';
import { Observable } from 'rxjs'

@Injectable()
export class UccUsersService {
    // uccUsersDoc: AngularFirestoreCollection<uccUsers>;
    uccItemsDoc: AngularFirestoreDocument<any>;
    uccItemsCol: Observable<uccUsers[]>;

    constructor(public afs: AngularFirestore) {
        // this.uccUsersDoc = this.afs.collection('Maintenance');
    }

    getUccUsers(obj) {
        this.uccItemsCol = this.afs.collection('UCC_PERMS', ref => ref
            .where('mobile', '==', obj.mob)
            .where('userUid', '==', obj.fbid)
            .where('name', '==', obj.name)
            .where('deviceId', '==', obj.deviceId))
            .valueChanges();
        return this.uccItemsCol;
    };

}



// WEBPACK FOOTER //
// ./src/app/reports/uccReport/uccUsers.service.ts